import React from 'react';
import {Card, Grid} from "@mui/material";
import FaiBox from "../../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../../MuiComponents/FaiTypography";
import theme from "../../../../../assets/theme";

// Expanded row for a refund: shows the breakdown the merchant cares about —
// what was refunded, where the money went, why, and the cross-reference ids.
function ExpandableComponent(row: any) {
    const {typography} = theme;
    const details = (row && (row.original?.details ?? row.details)) || {};

    const line = (label: string, value: any) => (
        <Grid container spacing={2}>
            <Grid item sm={6} md={5}>
                <FaiTypography variant={"caption"}>{label}</FaiTypography>
            </Grid>
            <Grid item sm={6} md={7}>
                <FaiTypography variant={"caption"} sx={{fontWeight: typography.fontWeightMedium}}>
                    {value ?? '—'}
                </FaiTypography>
            </Grid>
        </Grid>
    );

    return (
        <FaiBox p={3}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <Card sx={{borderRadius: "8px", minWidth: "255px", minHeight: "148px"}}>
                        <FaiBox p={"7px 12px 7px 12px"}>
                            <FaiBox mb={1}>
                                <FaiTypography variant={"caption"} sx={{fontWeight: typography.fontWeightMedium}}>
                                    Refund details
                                </FaiTypography>
                            </FaiBox>
                            {line("Refund type", details.refundType)}
                            {line("Reason", details.reason)}
                            {line("Payment mode", details.paymentMode)}
                            {line("Destination", details.destination)}
                            {line("Quantity", details.quantity)}
                        </FaiBox>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <Card sx={{borderRadius: "8px", minWidth: "255px", minHeight: "148px"}}>
                        <FaiBox p={"7px 12px 7px 12px"}>
                            <FaiBox mb={1}>
                                <FaiTypography variant={"caption"} sx={{fontWeight: typography.fontWeightMedium}}>
                                    References
                                </FaiTypography>
                            </FaiBox>
                            {line("Order id", details.razorpayOrderId)}
                            {line("Razorpay refund id", details.razorpayRefundId)}
                            {line("Customer id", details.customerId)}
                        </FaiBox>
                    </Card>
                </Grid>
            </Grid>
        </FaiBox>
    );
}

export default ExpandableComponent;
